export const MAIN_WRAPPER = '1100px';
export const SUB_WRAPPER = '950px';
export const TABLET_WRAPPER = '800px';
export const SUB_TABLET_WRAPPER = '750px';
